import "@theme/front/init.scss";

import "bootstrap-front/js/dist/dropdown";
import "bootstrap-front/js/dist/collapse";

import "lightbox2/dist/css/lightbox.css";
// eslint-disable-next-line no-unused-vars
import lightbox from "lightbox2/dist/js/lightbox";

import Nette from "@/front/netteForms";
Nette.initOnLoad();
window.Nette = Nette;

const links = document.querySelectorAll(".navbar-nav a");
const navigation = document.querySelector(".navbar-collapse");
const navbarToggler = document.querySelector(".navbar-toggler");

document.addEventListener("DOMContentLoaded", () => {


    // scroll-to-top button
    const scrollTopBtn = document.querySelector(".scroll-to-top")
    document.addEventListener('scroll', () => {
        if (window.scrollY > (window.innerHeight / 2))
            scrollTopBtn.style.right = "0px"
        else
            scrollTopBtn.style.right = "-50px"
    })

    // close navbar on link click
    links.forEach((link) => {
        link.addEventListener("click", () => {
            if (navigation.classList.contains("show") && link.classList.contains("scroll")) {
                navigation.classList.remove("show");
                navbarToggler.checked = !navbarToggler.checked;
            }
        });
    });

    // smooth scroll
    $(document).ready(function(){
        // Add smooth scrolling to all links
        $(".scroll").on("click", function(event) {

            // Make sure this.hash has a value before overriding default behavior
            if (this.hash !== "") {
                // Prevent default anchor click behavior
                event.preventDefault();

                // Store hash
                var hash = this.hash;

                // Using jQuery's animate() method to add smooth page scroll
                // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
                $("html, body").animate({
                    scrollTop: $(hash).offset().top
                }, 800, function(){

                    // Add hash (#) to URL when done scrolling (default click behavior)
                    window.location.hash = hash;
                });
            } // End if
        });
    });

});
